export default {
  subjectList: []
}
